import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';
import { ObjectShim } from '@packages/helpers/core/shims/object-shim';
import { getStaticData } from '../../store/reducers/static-data';

const DD_GROUP_IDENTIFIER = 'widgetConfiguration';

export const withWidgetConfigData = widgetName =>
  compose(
    connect(
      ({ staticData }, { loading }) => ({
        loading: loading || staticData.loading[DD_GROUP_IDENTIFIER],
        widgetConfiguration: staticData[DD_GROUP_IDENTIFIER]?.[widgetName] ?? {}
      }),
      { getStaticData }
    ),
    withHandlers({
      fetchWidgetConfig:
        ({ getStaticData, widgetConfiguration }) =>
        () => {
          if (ObjectShim.isEmpty(widgetConfiguration)) getStaticData(DD_GROUP_IDENTIFIER);
        }
    })
  );
